import { create } from "zustand";

export const useCustomerInfoB2CStore = create((set, get) => ({
  customerInfoB2C: {
    email: "",
    displayName: "",
    fullName: "",
  },

  setCustomerInfoB2C: (name, value) => {
    set((state) => ({
      customerInfoB2C: { ...state.customerInfoB2C, [name]: value },
    }));

    sessionStorage.setItem(
      "LS_CUSTOMER_INFO",
      JSON.stringify(get().customerInfoB2C)
    );
  },
}));
